import React from 'react';
export var isChildElement = element => {
  return typeof element === 'object' && /*#__PURE__*/React.isValidElement(element);
};